import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Button, Typography } from '@mui/material';

const buttonSx = {
  fontSize: { xs: '0.8rem', sm: '0.8rem', md: '0.9rem' },
  mt: 2,
  width: '100%',
  borderRadius: '14px',
  py: 2,
  backgroundColor: '#EFEEF3',
  color: '#2F2D3A',
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#E6E5EB',
  },
};

const infoCardSx = {
  backgroundColor: '#EFEEF3',
  borderRadius: '14px',
  py: 2,
  px: 2.5,
};

const getErrorDetailText = (detail) => {
  if (typeof detail === 'string') {
    return detail;
  }

  if (typeof detail === 'object' && detail !== null) {
    if (detail.description) {
      const detailsList =
        Array.isArray(detail.details) && detail.details.length > 0 ? detail.details.join(', ') : '';
      return detailsList ? `${detail.description}: ${detailsList}` : detail.description;
    }
    return detail?.detail || detail?.message || JSON.stringify(detail);
  }

  return String(detail || '');
};

const LinkedUpStatusDetails = ({
  type,
  folio = '-',
  date = '-',
  errorDetails = [],
  onDownload,
  onRetry,
  onAccept,
  onPoll,
  isDownloadPdf,
  downloadPdfError,
}) => {
  if (type === 'success') {
    return (
      <Box>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            gap: 2,
          }}
        >
          <Box sx={infoCardSx}>
            <Typography sx={{ color: '#2F2D3A', fontWeight: 400, fontSize: '1rem' }}>
              Folio:
            </Typography>
            <Typography sx={{ color: '#2F2D3A', fontWeight: 700, fontSize: '1rem' }}>
              {folio}
            </Typography>
          </Box>

          <Box sx={infoCardSx}>
            <Typography sx={{ color: '#2F2D3A', fontWeight: 400, fontSize: '1rem' }}>
              Fecha:
            </Typography>
            <Typography sx={{ color: '#2F2D3A', fontWeight: 700, fontSize: '1rem' }}>
              {date}
            </Typography>
          </Box>
        </Box>

        {downloadPdfError ? (
          <Button
            onClick={onDownload}
            variant='text'
            startIcon={<RefreshIcon sx={{ color: '#724ecb' }} />}
            sx={buttonSx}
          >
            Reintentar
          </Button>
        ) : (
          <Button
            onClick={onDownload}
            variant='text'
            startIcon={<FileDownloadOutlinedIcon sx={{ color: '#724ecb' }} />}
            sx={buttonSx}
          >
            {isDownloadPdf ? 'Descargando PDF...' : 'Descargar acuse y finalizar'}
          </Button>
        )}
      </Box>
    );
  }

  if (type === 'error-details') {
    return (
      <Box>
        <Box sx={{ backgroundColor: '#f5f4f9', borderRadius: '14px', px: 2, py: 1.5 }}>
          <Typography sx={{ fontSize: '1rem', fontWeight: 700, mb: 0.75 }}>
            Motivo del rechazo:
          </Typography>

          {errorDetails.map((detail, index) => (
            <Typography
              key={`${getErrorDetailText(detail)}-${index}`}
              sx={{
                fontSize: '0.9rem',
                mb: index < errorDetails.length - 1 ? 0.75 : 0,
              }}
            >
              {getErrorDetailText(detail)}
            </Typography>
          ))}
        </Box>

        <Button onClick={onAccept} variant='text' sx={buttonSx}>
          Aceptar
        </Button>
      </Box>
    );
  }

  if (type === 'retry') {
    return (
      <Button onClick={onRetry} variant='text' sx={buttonSx}>
        Volver a intentar
      </Button>
    );
  }

  if (type === 'error') {
    return (
      <Button onClick={onAccept} variant='text' sx={buttonSx}>
        Aceptar
      </Button>
    );
  }

  if (type === 'pending') {
    return (
      <Button onClick={onPoll} variant='text' sx={buttonSx}>
        Consultar nuevamente
      </Button>
    );
  }

  return null;
};

export default LinkedUpStatusDetails;
